import { RequestStatus } from "../../../request";
import { CampaignDetails } from "../default/reducer";

export interface CampaignDetailsState {
  genderOptions: TargetingOption[];
  osOptions: TargetingOption[];
  countryOptions: TargetingOption[];

  fetchedAppIconUrl: string | null;

  updateCampaignRequestState: RequestStatus;
  
  campaignDetails: CampaignDetails | null;
  fetchCampaignRequestState: RequestStatus;
}

export const initialState: CampaignDetailsState = {
  genderOptions: [],
  osOptions: [],
  countryOptions: [],

  fetchedAppIconUrl: null,

  updateCampaignRequestState: {
    isSuccessful: false,
    isFailed: false,
    isLoading: false,
  },

  campaignDetails: null,
  fetchCampaignRequestState: {
    isSuccessful: false,
    isFailed: false,
    isLoading: false,
  },
};

export function CampaignDetailsReducer(state = initialState, action: any) {
  switch (action.type) {
    case "campaign-details-update-fetched-app-icon-url":
      return {
        ...state,
        fetchedAppIconUrl: action.iconUrl,
      };
    case "campaign-details-update-campaign-request-state":
      return {
        ...state,
        updateCampaignRequestState: action.requestState,
      };
    case "campaign-details-update-gender-options":
      return {
        ...state,
        genderOptions: action.options,
      };
    case "campaign-details-update-os-options":
      return {
        ...state,
        osOptions: action.options,
      };
    case "campaign-details-update-country-options":
      return {
        ...state,
        countryOptions: action.options,
      };
    case "campaign-details-update-campaign":
      return {
        ...state,
        campaignDetails: action.campaign,
      };
    case "campaign-details-update-fetch-campaign-request-state":
      return {
        ...state,
        fetchCampaignRequestState: action.requestState,
      };
    case "reset-data":
      return initialState;
    default:
      return state;
  }
}

export interface TargetingOption {
  label: string;
  value: string | number;
}
